import { FC } from 'react';

import { PhoneHistoryItem } from '@shared/api/giftCoupon/giftCoupon.interface';

import { historyStatusLabel } from '../utils/redemption.constants';
import { formatDate, formatPhone } from '../utils/redemption.utils';

interface Props {
  phone: string;
  history: PhoneHistoryItem[];
  onClose: () => void;
}

export const PhoneHistoryModal: FC<Props> = ({ phone, history, onClose }) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="fixed inset-0 bg-black/50" onClick={onClose} />
      <div className="relative max-h-[80vh] w-full max-w-lg overflow-hidden rounded-xl bg-white shadow-2xl">
        <div className="border-b bg-red-50 px-6 py-4">
          <div className="flex items-center gap-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5 text-red-600"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fillRule="evenodd"
                d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                clipRule="evenodd"
              />
            </svg>
            <h3 className="text-lg font-bold text-red-800">
              과거 교환 이력 - {formatPhone(phone)}
            </h3>
          </div>
          <p className="mt-1 text-sm text-red-600">
            이 번호로 과거 <span className="font-bold">{history.length}건</span>의 교환
            이력이 있습니다.
          </p>
        </div>
        <div className="max-h-[60vh] overflow-y-auto px-6 py-4">
          <div className="space-y-3">
            {history.map((item, idx) => {
              const badge = historyStatusLabel[item.redeemStatus] ?? {
                text: item.redeemStatus,
                className: 'bg-gray-100 text-gray-600',
              };
              return (
                <div
                  key={idx}
                  className="flex items-center gap-3 rounded-lg border border-gray-200 px-4 py-3"
                >
                  <span
                    className={`shrink-0 rounded-full px-2 py-0.5 text-xs font-semibold ${badge.className}`}
                  >
                    {badge.text}
                  </span>
                  <div className="min-w-0 flex-1">
                    <p className="text-sm text-gray-900">
                      {item.selectedChoiceUnit?.name || '-'}
                    </p>
                    <p className="text-xs text-gray-500">
                      {formatDate(item.requestedAt)} · {item.ordererName} 주문
                    </p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
        <div className="border-t px-6 py-3">
          <button
            onClick={onClose}
            className="w-full rounded-lg border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
          >
            닫기
          </button>
        </div>
      </div>
    </div>
  );
};
